import { combineMapKey, getFeatureData } from 'config-request';
import { CategoryCode, FeatureType, SubCategoryCode, } from 'config-request/src/interfaces/feature-list';
import { defineStore } from 'pinia';
import { useFeatureListStore } from './feature-list';
import { useGlobalStore } from './global';
import { usePriceListStore } from './price-list';
export const useInteriorStore = defineStore('interior', {
    getters: {
        /**
         * 内饰颜色列表
         */
        interiorColorList() {
            const featureListStore = useFeatureListStore();
            if (!featureListStore.data)
                return [];
            const colorCodes = [
                CategoryCode.Cockpit,
                SubCategoryCode.Interior,
                FeatureType.CockpitInteriorColor,
            ];
            const featureItem = getFeatureData(colorCodes, featureListStore.data);
            return featureItem?.option_list?.map((option) => featureListStore.data?.option_map[option]);
        },
        /**
         * 内饰材质列表
         */
        interiorMaterialList() {
            const featureListStore = useFeatureListStore();
            if (!featureListStore.data)
                return [];
            const colorCodes = [
                CategoryCode.Cockpit,
                SubCategoryCode.Interior,
                FeatureType.CockpitInteriorMaterial,
            ];
            const featureItem = getFeatureData(colorCodes, featureListStore.data);
            return featureItem?.option_list?.map((option) => featureListStore.data?.option_map[option]);
        },
        discountData() {
            const globalStore = useGlobalStore();
            const featureListStore = useFeatureListStore();
            const priceList = usePriceListStore();
            const featureDiscountTip = featureListStore.data?.option_map[globalStore.currentOptions.F00024]
                ?.discount_tip ||
                featureListStore.data?.option_map[globalStore.currentOptions.F00004]
                    ?.discount_tip ||
                '';
            const featureDiscountSourceFirst = featureListStore.data?.option_map[globalStore.currentOptions.F00024];
            const featureDiscountSourceSecond = featureListStore.data?.option_map[globalStore.currentOptions.F00004];
            const featureDiscountSource = (featureDiscountSourceFirst &&
                (featureDiscountSourceFirst?.discount_tip_icon ||
                    featureDiscountSourceFirst?.discount_tip_icon_ratio))
                ? featureDiscountSourceFirst
                : featureDiscountSourceSecond || {};
            const featureDiscountTipIcon = featureDiscountSource?.discount_tip_icon || '';
            const featureDiscountTipIconRatio = featureDiscountSource?.discount_tip_icon_ratio || '';
            const priceDiscountTip = priceList.data?.configurator_select_discount_tip_map?.[globalStore.currentOptions.F00024] ||
                priceList.data?.configurator_select_discount_tip_map?.[globalStore.currentOptions.F00004];
            const priceDiscountTipIcon = priceList.data?.configurator_select_discount_tip_icon_map?.[globalStore.currentOptions.F00024] ||
                priceList.data?.configurator_select_discount_tip_icon_map?.[globalStore.currentOptions.F00004] || {
                icon: '',
                icon_ratio: '',
            };
            const discountData = {
                discount_selected: !!priceDiscountTip,
                discount_tip: priceDiscountTip || featureDiscountTip || '',
                discount_tip_icon: priceDiscountTipIcon?.icon || featureDiscountTipIcon || '',
                discount_tip_icon_ratio: priceDiscountTipIcon?.icon_ratio || featureDiscountTipIconRatio || '',
            };
            return discountData;
        },
        /**
         * 当前选中的组合数据
         */
        currentData() {
            const globalStore = useGlobalStore();
            const featureListStore = useFeatureListStore();
            const combinedKey = combineMapKey(globalStore.currentOptions.F00024, globalStore.currentOptions.F00004);
            const combinedData = featureListStore.data?.option_combine_map[combinedKey];
            return {
                combinedData: combinedData,
                colorData: featureListStore.data?.option_map[globalStore.currentOptions.F00004],
                materialData: featureListStore.data?.option_map[globalStore.currentOptions.F00024],
            };
        },
    },
});
